import './vendor/polyfills'
import './vendor/helpers'
import externalLinks from './modules/externalLinks'
import dropdowns from './modules/dropdowns'
import contentSets from './modules/contentSets'
import forms from './modules/forms'
import fetchLists from './modules/fetchLists'
import sliders from './modules/sliders'
import mobileDevices from './modules/mobileDevices'
import layout from './modules/layout'
import LazyLoad from 'vanilla-lazyload'
import 'lightgallery.js'
import 'lg-video.js'
import 'lightgallery.js/dist/css/lightgallery.css'

window.lazyLoad = new LazyLoad({
  elements_selector: '.lazy'
})

document.addEventListener('DOMContentLoaded', () => {
  externalLinks()
  dropdowns()
  contentSets()
  forms()
  fetchLists()
  sliders()
  mobileDevices()
  document.querySelectorAll('.lightgallery').forEach(gallery => window.lightGallery(gallery))
  document.querySelectorAll('.lightgallery-iframe').forEach(iframe => window.lightGallery(iframe, {
    selector: 'this',
    videoMaxWidth: '100%',
    download: false,
  }))
})

window.addEventListener('load', function () {
  layout()
})



// WEBPACK FOOTER //
// ./themes/default/js/main.js